import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Domek from "@/pages/Domek";
import Workation from "@/pages/Workation";
import Okolica from "@/pages/Okolica";
import Kontakt from "@/pages/Kontakt";
import Admin from "@/pages/Admin";

export default function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/domek" element={<Domek />} />
              <Route path="/workation" element={<Workation />} />
              <Route path="/okolica" element={<Okolica />} />
              <Route path="/kontakt" element={<Kontakt />} />
            </Route>
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}
